import React, { useState } from 'react';
import moment from 'moment';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { REGULATION_FEED, RegSeverity } from './regulationsMock';

/**
 * Regulations tab (spec §5.6) — design-only. A proactive feed of export
 * regulatory news with a mocked "affects N of your products" indicator.
 */

const SEVERITY_DOT: Record<RegSeverity, string> = {
  info: 'eh-reg-dot-info',
  warning: 'eh-reg-dot-warning',
  danger: 'eh-reg-dot-danger',
};

const SOURCES = ['All', 'BIS', 'DDTC', 'OFAC', 'NRC', 'Federal Register', 'Commerce'];

const RegulationsTab: React.FC = () => {
  const [source, setSource] = useState('All');

  const items =
    source === 'All'
      ? REGULATION_FEED
      : REGULATION_FEED.filter((r) => r.source === source);

  return (
    <div className='export-hub-panel'>
      <div className='eh-intg-intro'>
        <h2 className='eh-intg-intro-title'>
          <CampaignOutlinedIcon
            style={{ fontSize: 20, marginRight: 8, verticalAlign: 'middle' }}
          />
          Regulatory Watch
          <span className='export-hub-preview-pill'>Preview</span>
        </h2>
        <p className='eh-intg-intro-sub'>
          The latest export-control changes — ECCN revisions, sanctions updates,
          and DDTC/BIS rules — with the products in your databases they touch.
        </p>
      </div>

      <div className='eh-reg-filters'>
        {SOURCES.map((s) => (
          <button
            key={s}
            type='button'
            className={`eh-reg-filter ${source === s ? 'active' : ''}`}
            onClick={() => setSource(s)}
          >
            {s}
          </button>
        ))}
      </div>

      <div className='eh-reg-feed'>
        {items.map((r) => (
          <div className='eh-reg-item' key={r.id}>
            <span className={`eh-reg-dot ${SEVERITY_DOT[r.severity]}`} />
            <div className='eh-reg-body'>
              <div className='eh-reg-meta'>
                <span className='eh-reg-source'>{r.source}</span>
                <span className='eh-reg-cat'>{r.category}</span>
                <span className='eh-reg-date'>
                  {moment(r.date).format('MMM D, YYYY')}
                </span>
              </div>
              <div className='eh-reg-title'>{r.title}</div>
              <div className='eh-reg-summary'>{r.summary}</div>
              {r.affects !== null && (
                <div className='eh-reg-affects'>
                  <Inventory2OutlinedIcon style={{ fontSize: 14 }} />
                  Affects {r.affects} of your product
                  {r.affects === 1 ? '' : 's'}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegulationsTab;
